export const allAnimals = {
  birds: {
    name: "Birds",
    product: "Eggs",
    productionTime: 1800, // 30 minutes in seconds
    variants: [
      {
        id: "birds",
        name: "Birds",
        rarity: [
          { 
            type: "Common", 
            name: "White Chicken",
            biopoints: 18.3, 
            image: "/images/animals/birds/common/preview.png",
            // Common is base, no upgrade requirements
            upgradeRequirements: null
          },
          { 
            type: "Uncommon", 
            name: "Brown Chicken",
            biopoints: 63, 
            image: "/images/animals/birds/uncommon/preview.png",
            upgradeRequirements: {
              animals: 2,
              animalName: "White Chicken",
              animalRarity: "Common",
              food: { type: "seeds", rarity: "Uncommon", amount: 3 },
              cfb: 30
            }
          },
          { 
            type: "Rare", 
            name: "Brown Turkey",
            biopoints: 91, 
            image: "/images/animals/birds/rare/preview.png",
            upgradeRequirements: {
              animals: 2,
              animalName: "Brown Chicken",
              animalRarity: "Uncommon",
              food: { type: "seeds", rarity: "Rare", amount: 7 },
              cfb: 75
            }
          },
          { 
            type: "Epic", 
            name: "Blue Turkey",
            biopoints: 123, 
            image: "/images/animals/birds/epic/preview.png",
            upgradeRequirements: {
              animals: 2,
              animalName: "Brown Turkey",
              animalRarity: "Rare",
              food: { type: "seeds", rarity: "Epic", amount: 15 },
              cfb: 150
            }
          },
          { 
            type: "Legendary", 
            name: "White Ostrich",
            biopoints: 224, 
            image: "/images/animals/birds/legendary/preview.png",
            upgradeRequirements: {
              animals: 2,
              animalName: "Blue Turkey",
              animalRarity: "Epic",
              food: { type: "seeds", rarity: "Legendary", amount: 30 },
              cfb: 300
            }
          }
        ]
      }
    ]
  },
  
  cattle: {
    name: "Cattle",
    product: "Milk",
    productionTime: 6600, // 1 hour 50 minutes in seconds
    variants: [
      {
        id: "cattle",
        name: "Cattle",
        rarity: [
          { 
            type: "Common",
            name: "Brown Goat",
            biopoints: 272, 
            image: "/images/animals/cattle/common/preview.png",
            // Common is base, no upgrade requirements
            upgradeRequirements: null
          },
          { 
            type: "Uncommon",
            name: "Grey Goat",
            biopoints: 466, 
            image: "/images/animals/cattle/uncommon/preview.png",
            upgradeRequirements: {
              animals: 2,
              animalName: "Brown Goat",
              animalRarity: "Common",
              food: { type: "hay", rarity: "Uncommon", amount: 5 },
              cfb: 50
            }
          },
          { 
            type: "Rare",
            name: "Brown Cow",
            biopoints: 661, 
            image: "/images/animals/cattle/rare/preview.png",
            upgradeRequirements: {
              animals: 2,
              animalName: "Grey Goat",
              animalRarity: "Uncommon",
              food: { type: "hay", rarity: "Rare", amount: 10 },
              cfb: 100
            }
          },
          { 
            type: "Epic",
            name: "White Cow",
            biopoints: 855, 
            image: "/images/animals/cattle/epic/preview.png",
            upgradeRequirements: {
              animals: 2,
              animalName: "Brown Cow",
              animalRarity: "Rare",
              food: { type: "hay", rarity: "Epic", amount: 20 },
              cfb: 200
            }
          },
          { 
            type: "Legendary",
            name: "Black Buffalo",
            biopoints: 1516, 
            image: "/images/animals/cattle/legendary/preview.png",
            upgradeRequirements: {
              animals: 2,
              animalName: "White Cow",
              animalRarity: "Epic",
              food: { type: "hay", rarity: "Legendary", amount: 40 },
              cfb: 400
            }
          }
        ]
      }
    ]
  },
  
  fuzzies: {
    name: "Fuzzies",
    product: "Wool",
    productionTime: 13800, // 3 hours 50 minutes in seconds
    variants: [
      {
        id: "fuzzies",
        name: "Fuzzies",
        rarity: [
          { 
            type: "Common", 
            name: "Chinchilla",
            biopoints: 120, 
            image: "/images/beds/fuzzies/common/preview.png",
            // Common is base, no upgrade requirements
            upgradeRequirements: null
          },
          { 
            type: "Uncommon", 
            name: "Angora Rabbit",
            biopoints: 240, 
            image: "/images/beds/fuzzies/uncommon/preview.png",
            // Upgrade requirements for Uncommon
            upgradeRequirements: {
              animals: 2,
              animalName: "Chinchilla",
              animalRarity: "Common",
              food: { type: "fuzzies", rarity: "Uncommon", amount: 3 },
              cfb: 50
            }
          },
          { 
            type: "Rare", 
            name: "Black Sheep",
            biopoints: 480, 
            image: "/images/beds/fuzzies/rare/preview.png",
            // Upgrade requirements for Rare
            upgradeRequirements: {
              animals: 2,
              animalName: "Angora Rabbit",
              animalRarity: "Uncommon",
              food: { type: "fuzzies", rarity: "Rare", amount: 7 },
              cfb: 100
            }
          },
          { 
            type: "Epic", 
            name: "Camel",
            biopoints: 960, 
            image: "/images/beds/fuzzies/epic/preview.png",
            // Upgrade requirements for Epic
            upgradeRequirements: {
              animals: 2,
              animalName: "Black Sheep",
              animalRarity: "Rare",
              food: { type: "fuzzies", rarity: "Epic", amount: 15 },
              cfb: 200
            }
          },
          { 
            type: "Legendary", 
            name: "Alpaca",
            biopoints: 1920, 
            image: "/images/beds/fuzzies/legendary/preview.png",
            // Upgrade requirements for Legendary
            upgradeRequirements: {
              animals: 2,
              animalName: "Camel",
              animalRarity: "Epic",
              food: { type: "fuzzies", rarity: "Legendary", amount: 30 },
              cfb: 400
            }
          }
        ]
      }
    ]
  },
  
  piggies: {
    name: "Piggies",
    product: "Truffle",
    productionTime: 14400, // 4 hours in seconds
    variants: [
      {
        id: "piggies",
        name: "Piggies",
        rarity: [
          { 
            type: "Common",
            name: "Charlotte",
            biopoints: 4100, 
            image: "/images/beds/piggies/common/preview.png",
            cardImage: "/images/farm/vegetables/truffle/common/card.png",
            // Common is base, no upgrade requirements
            upgradeRequirements: null
          }
        ]
      }
    ]
  }
};

// Function to format production time in hours and minutes
const formatProductionTime = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  return `${hours > 0 ? `${hours}h ` : ''}${minutes}m`;
};

export { formatProductionTime };
